import { Injectable } from "@angular/core";

import { BehaviorSubject, Observable } from "rxjs";

export interface Toast {
  id: number;
  message: string;
  type: "success" | "error" | "warning" | "info";
  timeout?: number;
}

@Injectable({
  providedIn: "root"
})
export class ToastService {
  private _currentId = 0;
  private _toasts$ = new BehaviorSubject<Toast[]>([]);

  getToasts(): Observable<Toast[]> {
    return this._toasts$.asObservable();
  }

  success(message: string, timeout = 5000): void {
    this.show({ message, type: "success", timeout });
  }

  error(message: string, timeout = 8000): void {
    this.show({ message, type: "error", timeout });
  }

  warning(message: string, timeout = 5000): void {
    this.show({ message, type: "warning", timeout });
  }

  info(message: string, timeout = 5000): void {
    this.show({ message, type: "info", timeout });
  }

  remove(id: number): void {
    const currentToasts = this._toasts$.value;
    this._toasts$.next(currentToasts.filter((toast) => toast.id !== id));
  }

  private show(params: Omit<Toast, "id">): void {
    const id = this._currentId++;
    const toast: Toast = { ...params, id };

    this._toasts$.next([...this._toasts$.value, toast]);

    if (params.timeout) {
      setTimeout(() => this.remove(id), params.timeout);
    }
  }
}
